import './scss/index.scss';

import ComponentsFactory from 'foundation/components-factory';
import QualifiedGolfersComponent from './js/qualified-golfers.component';

ComponentsFactory.getInstance().define('qualified-golfers', QualifiedGolfersComponent);
